import {
    IProps,
    IRef,
} from '../types';

import React, {
    forwardRef,
    useImperativeHandle,
    useState,
} from 'react';

import {
    CLIENT_FIELD_TYPE,
} from 'entities/payment-methods/constants';

import {
    DateTimeInput,
} from 'components/inputs';

import {
    checkValue,
} from './helpers/check-value';

const DateTimeFieldInput = forwardRef<IRef, IProps>((props, ref) => {
    const [value, setValue] = useState<string | null>(null);
    const [isError, setIsError] = useState(false);

    const onChangeValue = (value: string | null) => {
        setValue(value);
        setIsError(false);
    };

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                return {
                    key: props.clientField.key,
                    value: value ?? '',
                };
            },
            setValue(value) {
                setValue(value?.value ?? null);
            },
            validate() {
                if (props.clientField.validation.type !== CLIENT_FIELD_TYPE.DATETIME) {
                    return false;
                }

                const isValid = checkValue(value);

                setIsError(!isValid);

                return isValid;
            },
        };
    });

    return (
        <DateTimeInput
            label={props.clientField.name}
            value={value}
            isDisabled={props.isDisabled}
            isError={isError}
            errorMessage={isError ? props.clientField.validationHint : null}
            onChangeValue={onChangeValue}
        />
    );
});

export default DateTimeFieldInput;
